import { render, staticRenderFns } from "./_base-hotspot.vue?vue&type=template&id=ea2e0c34&"
import script from "./_base-hotspot.vue?vue&type=script&lang=js&"
export * from "./_base-hotspot.vue?vue&type=script&lang=js&"
import style0 from "./_base-hotspot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports